// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2lvV6","productName":"Table_productName__26qtz"};